import React from "react";

import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import { Box, IconButton, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import useBooleanToggle from "@/hooks/useBooleanToggle";

import AppBar, { APP_BAR_HEIGHT } from "./AppBar";
import GlobalListeners from "./GlobalListeners";
import Sidebar from "./Sidebar";

const useStyles = makeStyles()({
  root: {
    display: "flex",
    height: "100vh",
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: APP_BAR_HEIGHT,
    overflow: "auto",
  },
});

const AppLayout: React.FC = () => {
  const theme = useTheme();
  const { classes } = useStyles();

  const [sidebarCollapsed, setSidebarCollapsed] = useBooleanToggle();

  const CollapseIcon =
    theme.direction === "rtl" ? ChevronRightIcon : ChevronLeftIcon;
  const ExpandIcon =
    theme.direction === "rtl" ? ChevronLeftIcon : ChevronRightIcon;

  return (
    <div className={classes.root}>
      <AppBar
        left={
          <Box>
            <IconButton onClick={setSidebarCollapsed.toggle} size="large">
              {sidebarCollapsed ? <ExpandIcon /> : <CollapseIcon />}
            </IconButton>
          </Box>
        }
      />
      <Sidebar collapsed={sidebarCollapsed} />
      <GlobalListeners>
        <Box className={classes.content}>
          <Outlet />
        </Box>
      </GlobalListeners>
    </div>
  );
};

export default AppLayout;
